if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"documentApp","remotes":[],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return /^(231|408|54|792|96)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}